import { fromJS } from 'immutable';
import validators from './validators';
import validationModel from 'modules/validations/model';
import fieldModel from 'shared-components/FormFields/model';

const lookupNested = (path, globalData) => {
  try {
    return path.split('.').reduce((currentObj, pathComponent) => {
      return currentObj[pathComponent];
    }, globalData);
  } catch (error) {
    return null;
  }
};

const getUrlParams = search => {
  let hashes = search.slice(search.indexOf('?') + 1).split('&');
  let params = {};
  hashes.map(hash => {
    let [key, val] = hash.split('=');
    params[key] = decodeURIComponent(val);
  });
  return params;
};
const searchParams = getUrlParams(window.location.search);
const isGifting = searchParams['gifting'];
const getGiftEmail = searchParams['email'];

export default (globalData) => {
  const csrf = lookupNested('csrf', globalData);
  const hasReferrerParam = globalData.hasOwnProperty('referrerCode');
  const phoneTooltip = lookupNested('mobilePhoneTooltip', globalData);
  const isReferral = lookupNested('isReferral', globalData);
  const passwordChecklist = lookupNested('passwordChecklist', globalData);
  const referrerCode = lookupNested('referrerCode', globalData);
  const tmSessionId = lookupNested('tmSessionId', globalData);

  const errors = lookupNested('errors', globalData) || {};
  const values = lookupNested('values', globalData) || {};
  if (!!values.phone) values.phone_formatted = `( ${values.phone.slice(0, 3)} ) ${values.phone.slice(3, 6)} - ${values.phone.slice(6)}`;

  const initialState = [
    fieldModel.create.field.input({
      key: 'EmailAddress',
      type: 'email',
      label: 'Email',
      placeholder: 'Email Address',
      name: 'user_registration_form[email]',
      isRequired: true,
      defaultValue: getGiftEmail || values.email || '',
      readOnly: isGifting,
      value: getGiftEmail || values.email || '',
      valid: errors.email ? false : undefined,
      error: errors.email ? errors.email[0] : undefined,
      validations: validationModel.createAll([validators.required, validators.email]),
    }),
    fieldModel.create.field.numberWithTemplate({
      key: 'PhoneNumber',
      label: 'Phone Number',
      placeholder: '( ### ) ### - ####',
      wildcardChars: '#',
      tooltip: phoneTooltip,
      name: 'user_registration_form[phone_formatted]',
      isRequired: true,
      input: { 'data-linkto-key': 'RawPhoneNumber' },
      valid: errors.phone ? false : undefined,
      error: errors.phone ? errors.phone[0] : undefined,
      defaultValue: values.phone || '',
      value: !!values.phone_formatted ? values.phone_formatted : '',
      validations: validationModel.createAll([validators.required, validators.mobilePhoneLength]),
    }),
    fieldModel.create.element.input({
      key: 'RawPhoneNumber',
      type: 'hidden',
      name: 'user_registration_form[phone]',
      defaultValue: values.phone || '',
    }),
    fieldModel.create.field.passwordWithMeter({
      key: 'Password',
      type: 'passwordWithMeter',
      label: 'Password',
      placeholder: 'Password',
      tooltip: passwordChecklist,
      name: 'user_registration_form[password]',
      isRequired: true,
      value: '',
      input: { autoComplete: 'off' },
      validations: validationModel.createAll([
        validators.required,
        validators.minLength,
        validators.specialCharacter,
        validators.capitalLetter,
        validators.digit,
      ]),
    }),
    fieldModel.create.field.input({
      key: 'PasswordConfirmation',
      type: 'password',
      label: 'Confirm Password',
      placeholder: 'Password',
      name: 'user_registration_form[password_confirmation]',
      isRequired: true,
      value: '',
      input: { autoComplete: 'off' },
      validations: validationModel.createAll([
        validators.required,
        { validator: validators.passwordConfirmation, matchKey: 'Password' },
      ]),
    }),
    fieldModel.create.element.input({
      key: 'AuthenticityToken',
      type: 'hidden',
      name: csrf.name,
      value: csrf.value,
    }),
  ];

  if (isReferral || hasReferrerParam) {
    initialState.push(fieldModel.create.field.input({
      key: 'ReferralCode',
      type: 'text',
      label: 'Referral Code',
      name: 'user_registration_form[referrer_code]',
      defaultValue: referrerCode || '',
      valid: errors.referrer_code ? false : undefined,
      error: errors.referrer_code ? errors.referrer_code[0] : undefined,
    }));
  }

  return fromJS(initialState);
};
